import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

// Brickmould — parent control
// None: hide all children
// Loose: show BrickmouldType + BrickmouldSize
// Installed: show BrickmouldType + BrickmouldSize + BrickmouldWidth + BrickmouldHeight
const OPTIONS = [
  { value: 'None',      label: 'None'      },
  { value: 'Loose',     label: 'Loose'     },
  { value: 'Installed', label: 'Installed' },
];

const Brickmould = ({
  value = { value: '', label: '' },
  onChange,
  disabled = false,
  onBrickmouldChildrenVisible, // (showTypeSize, showDimensions)
}) => {
  const [selected, setSelected] = useState(value?.value || '');

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
    const showTypeSize   = v === 'Loose' || v === 'Installed';
    const showDimensions = v === 'Installed';
    onBrickmouldChildrenVisible?.(showTypeSize, showDimensions);
  };

  return (
    <div className="a-container">
      <label htmlFor="SdBrickmould">Brickmould</label>
      <select id="SdBrickmould" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Brickmould;
